import { gql } from "@apollo/client";

export const AssetIotConnectionId = gql`
    query AssetIotConnectionId ($id: ID!) {
        assetLocation (id: $id) {
            id
            iotConnection {
                id
            }
        }
    }
`;
